module.exports = __webpack_public_path__ + "img/rank_silver.81533410.png";